module.exports = require('@nerdwallet/structured-content-core/tree-utils');
